const Default = () => {
  return <h1>404</h1>;
};

export default Default;
